var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMentionGroupAvtar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38.275px",
    height: "37.75px",
    viewBox: "0 0 38.275 37.75",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Contacts-List-Copy-6",
    transform: "translate(-20.362500, -373.000000)",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    transform: "translate(21.000000, 373.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,20.8717949 L0,16.8579882 C0,13.3111654 2.48318596,10.4358974 5.54635108,10.4358974 L12.4792899,10.4358974 C15.5424551,10.4358974 18.025641,13.3111654 18.025641,16.8579882 L18.025641,20.8717949",
    id: "Path",
    strokeWidth: 1.275,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.974359,20.8717949 L18.974359,16.8579882 C18.974359,13.3111654 21.4575449,10.4358974 24.5207101,10.4358974 L31.4536489,10.4358974 C34.516814,10.4358974 37,13.3111654 37,16.8579882 L37,20.8717949",
    id: "Path-Copy",
    strokeWidth: 1.275,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.53846154,37 L8.53846154,32.2564103 C8.53846154,28.0647106 11.4137295,24.6666667 14.9605523,24.6666667 L22.9881657,24.6666667 C26.5349885,24.6666667 29.4102564,28.0647106 29.4102564,32.2564103 L29.4102564,37",
    id: "Path-Copy-2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeWidth: 1.275,
    fill: "#FFFFFF",
    cx: 9.01282051,
    cy: 6.16666667,
    r: 5.52916667
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    strokeWidth: 1.275,
    fill: "#FFFFFF",
    cx: 27.9871795,
    cy: 6.16666667,
    r: 5.52916667
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    cx: 19.4487179,
    cy: 19.4487179,
    r: 6.36538462
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentionGroupAvtar);
export default __webpack_public_path__ + "static/media/mention-group-avtar.d84d1c64.svg";
export { ForwardRef as ReactComponent };